import React, { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button, Container } from "reactstrap";
import { getData, putData } from "../../api/method";
import Footer from "../../components/user/Footer";

const username = localStorage.getItem("username");

function Information() {
  const phoneRegExp = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  const emailRegExp =
    /^[a-z][a-z0-9_\.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/;
  const nameRegExp = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;

  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    username: "",
  });

  const onChangeValue = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const [error, setError] = useState({});

  const validationEdit = (e) => {
    const msg = {};

    if (data.firstname === "") {
      msg.firstname = "First name is requied!";
    } else if (!data.firstname.match(nameRegExp)) {
      msg.firstname = "First name is valid. Not number!";
    }

    if (data.lastname === "") {
      msg.lastname = "Last name is requied!";
    } else if (!data.lastname.match(nameRegExp)) {
      msg.lastname = "Last name is valid. Not number!";
    }

    if (data.phone === "") {
      msg.phone = "Phone is requied!";
    } else if (!data.phone.match(phoneRegExp)) {
      msg.phone = "Phone is valid. Start 84-03-05-07-08-06-09!";
    }

    if (data.email === "") {
      msg.email = "Email is requied!";
    } else if (!data.email.match(emailRegExp)) {
      msg.email = "Email is valid!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUpEdit = () => {
    validationEdit();
  };

  const [dataEdit, setDataEdit] = useState([]);

  const getCustomerByEdit = async () => {
    try {
      const result = await getData(`/api/User/${username}`);
      setDataEdit(result.data);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCustomerByEdit();
  }, []);

  const handleSubmitEdit = async () => {
    const isValid = validationEdit();
    const editData = new FormData();

    if (isValid) {
      editData.append("username", username);
      editData.append("lastname", data.lastname);
      editData.append("firstname", data.firstname);
      editData.append("email", data.email);
      editData.append("phone", data.phone);

      try {
        const res = await putData(`/api/User/${username}`, editData);
        if (res.status === 200) {
          toast.success("Edit success!");
        }
      } catch (error) {
        console.log(error);
        toast.error("Edit fail!");
      }
    }
  };

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          Information
        </p>
      </div>

      <Container>
        <div className="py-5">
          <div className="w-100 d-flex">
            <div className="w-40 text-end me-4">
              <p className="info_user fs-20 t-grey">Username</p>
              <p className="info_user fs-20 t-grey">Last Name</p>
              <p className="info_user fs-20 t-grey">First Name</p>
              <p className="info_user fs-20 t-grey">Phone</p>
              <p className="info_user fs-20 t-grey">Email</p>
            </div>

            <div className="w-60 text-start d-flex flex-column">
              <p className="info_user fs-20">ngocvan</p>

              <div className="info_user fs-20">
                <input
                  className="px-2"
                  type="text"
                  defaultValue={dataEdit.lastname}
                  onKeyUp={handleKeyUpEdit}
                  onChange={onChangeValue}
                  name="lastname"
                />
              </div>
              
              {error.lastname && (
                <p className="error text-start mt-0">{error.lastname}</p>
              )}

              <div className="info_user fs-20">
                <input
                  className="px-2"
                  type="text"
                  onKeyUp={handleKeyUpEdit}
                  defaultValue={dataEdit.firstname}
                  onChange={onChangeValue}
                  name="firstname"
                />
              </div>

              {error.firstname && (
                <p className="error text-start mt-0">{error.firstname}</p>
              )}

              <div className="info_user fs-20">
                <input
                  className="px-2"
                  type="text"
                  onKeyUp={handleKeyUpEdit}
                  defaultValue={dataEdit.phone}
                  onChange={onChangeValue}
                  name="phone"
                />
              </div>

              {error.phone && (
                <p className="error text-start mt-0">{error.phone}</p>
              )}

              <div className="info_user fs-20">
                <input
                  className="px-2"
                  type="text"
                  onKeyUp={handleKeyUpEdit}
                  defaultValue={dataEdit.email}
                  onChange={onChangeValue}
                  name="email"
                />
              </div>

              {error.email && (
                <p className="error text-start mt-0">{error.email}</p>
              )}
            </div>
          </div>

          <div className="w-60 ms-auto mt-4">
            <Button
              className="btn_order px-5 py-1 ms-3"
              onClick={() => handleSubmitEdit()}
            >
              Save
            </Button>
          </div>
        </div>
      </Container>

      <Footer />
    </div>
  );
}

export default Information;
